export default __webpack_public_path__ + "static/media/matterbase_logo_mobile_white.6a03af17.svg";